import userType from "./userType";


export const handleSetUserDetail =(data)=>({
type: userType.SET_LOGIN_USER,
payload: data
 })
 
export const handleLogOutUser =(data)=>({
type: userType.SET_LOGOUT_USER,
 })

 export const handleSetDetailForUpdate =(data)=>({
     type: userType.SET_UPDATE_USER_DETAIL,
     payload: data
 })

 

